/*
 * サブシステム名：
 * 機能名：配車表入力
 * 表示項目カスタマイズ(桜花)
 */
import D2PLMD1010 from '@/views/PLM/D2PLMD1010.js'
import filter from '@/rahmen/utils/filters'

import indexeddb from '@/ddv2.library/indexeddb'

export default {
  extends: D2PLMD1010,
  name: 'HaishaMeisaiListEditCustomForOka',
  methods: {

    /**
     * 運賃自動計算ボタンをツールバー一番左に配置する(桜花運輸専用)
     */
    isUnchinAutoCalcButtonPrepend: function () {
      return true
    },

    /**
     * 一覧ヘッダ作成
     */
    setHeader: function () {
      const self = this
      return new Promise(resolve => {
        // 現在日付取得
        const target = filter.dateFormatter(new Date())

        // 営業所コード取得
        const me = indexeddb.getRecord(self.eigyoshoList, self.conditions.haishaEigyoshoId)

        // --------------------------------------------------------------------------------
        // スプレッド用ドロップダウン作成
        // --------------------------------------------------------------------------------
        // 営業所
        var wkEigyoshoList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mEigyoshoLisst = self.eigyoshoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
        })
        const tEigyoshoList = mEigyoshoLisst.map(elem => {
          return {
            id: elem.eigyoshoNm,
            name: elem.eigyoshoNm,
            title: elem.eigyoshoCd
          }
        })
        wkEigyoshoList = wkEigyoshoList.concat(tEigyoshoList)

        // 配車先
        var wkHaishasakiList = ['自社', '傭車']

        // 乗務員
        var wkJomuinList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mJomuinList = self.eigyoshoJininList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && ([undefined, null].includes(me) || elem.eigyoshoCd === me.eigyoshoCd) && elem.jomuFlg === true
        })
        const tJomuinList = mJomuinList.map(elem => {
          return {
            id: elem.jininNmSei,
            name: elem.jininNmSei,
            title: elem.jininCd
          }
        })
        wkJomuinList = wkJomuinList.concat(tJomuinList)

        // 車両
        var wkSharyoList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mSharyoList = self.sharyoList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter(function (elem) {
          return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
        })
        const tSharyoList = mSharyoList.map(elem => {
          return {
            id: elem.jidoshaHyojiNm,
            name: elem.jidoshaHyojiNm,
            title: elem.sharyoNo
          }
        })
        wkSharyoList = wkSharyoList.concat(tSharyoList)

        // 傭車先
        var wkYoshasakiList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mYoshasakiList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
        })
        const tYoshasakiList = mYoshasakiList.map(elem => {
          return {
            id: elem.torihikisakiNm,
            name: elem.torihikisakiNm,
            title: elem.torihikisakiCd
          }
        })
        wkYoshasakiList = wkYoshasakiList.concat(tYoshasakiList)

        // 得意先
        var wkTokuisakiList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mTokuisakiList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
        })
        const tTokuisakiList = mTokuisakiList.map(elem => {
          return {
            id: elem.torihikisakiNm,
            name: elem.torihikisakiNm,
            title: elem.torihikisakiCd
          }
        })
        wkTokuisakiList = wkTokuisakiList.concat(tTokuisakiList)

        // 荷受人
        var wkNiukeninList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mNiukeninList = self.torihikisakiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tNiukeninList = mNiukeninList.map(elem => {
          return {
            id: elem.torihikisakiNm,
            name: elem.torihikisakiNm,
            title: elem.torihikisakiCd
          }
        })
        wkNiukeninList = wkNiukeninList.concat(tNiukeninList)

        // 発着地
        var wkHacchakuchiList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mHacchakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tHacchakuchiList = mHacchakuchiList.map(elem => {
          return {
            id: elem.hacchakuchiNm,
            name: elem.hacchakuchiNm,
            title: elem.hacchakuchiCd
          }
        })
        wkHacchakuchiList = wkHacchakuchiList.concat(tHacchakuchiList)

        // 発地
        var wkHatsuchiList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mHatsuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hatsuchiFlg
        })
        const tHatsuchiList = mHatsuchiList.map(elem => {
          return {
            id: elem.HatsuchiNm,
            name: elem.HatsuchiNm,
            title: elem.HatsuchiCd
          }
        })
        wkHatsuchiList = wkHatsuchiList.concat(tHatsuchiList)

        // 経由地
        var wkKeiyuchiList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mKeiyuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.keiyuchiFlg
        })
        const tKeiyuchiList = mKeiyuchiList.map(elem => {
          return {
            id: elem.KeiyuchiNm,
            name: elem.KeiyuchiNm,
            title: elem.KeiyuchiNm
          }
        })
        wkKeiyuchiList = wkKeiyuchiList.concat(tKeiyuchiList)

        // 着地
        var wkChakuchiList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mChakuchiList = self.hacchakuchiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.chakuchiFlg
        })
        const tChakuchiList = mChakuchiList.map(elem => {
          return {
            id: elem.ChakuchiNm,
            name: elem.ChakuchiNm,
            title: elem.ChakuchiNm
          }
        })
        wkChakuchiList = wkChakuchiList.concat(tChakuchiList)

        // 商品
        var wkShohinList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mShohinList = self.hinmeiList.map((elem) => {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
          return elem
        }).filter((t) => {
          return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
        })
        const tShohinList = mShohinList.map(elem => {
          return {
            id: elem.hinmeiNm,
            name: elem.hinmeiNm,
            title: elem.hinmeiCd
          }
        })
        wkShohinList = wkShohinList.concat(tShohinList)

        // 品目種別
        var wkHinmokuShubetsuList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mHinmokuShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVIJ02' && elem.kaishaCd === self.currentKaishaCode
        })
        const tHinmokuShubetsuList = mHinmokuShubetsuList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkHinmokuShubetsuList = wkHinmokuShubetsuList.concat(tHinmokuShubetsuList)

        // 単位
        var wkTaniShubetsuList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mTaniShubetsuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SVI001' && elem.kaishaCd === self.currentKaishaCode
        })
        const tTaniShubetsuList = mTaniShubetsuList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkTaniShubetsuList = wkTaniShubetsuList.concat(tTaniShubetsuList)

        // 運賃計算区分
        var wkUnchinKeisanKubunList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mUnchinKeisanKubunList = self.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF055' && elem.kaishaCd === self.currentKaishaCode && ['01', '02', '03'].includes(elem.code)
        })
        const tUnchinKeisanKubunList = mUnchinKeisanKubunList.map(elem => {
          return {
            id: elem.codeNm,
            name: elem.codeNm,
            title: elem.codeNm
          }
        })
        wkUnchinKeisanKubunList = wkUnchinKeisanKubunList.concat(tUnchinKeisanKubunList)

        // 請求車種
        var wkShashuList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mShashuList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'GVI011' && elem.kaishaCd === self.currentKaishaCode
        })
        const tShashuList = mShashuList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkShashuList = wkShashuList.concat(tShashuList)

        // 荷姿種別
        var wkNisugataList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mNisugataList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT019' && elem.kaishaCd === self.currentKaishaCode
        })
        const tNisugataList = mNisugataList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkNisugataList = wkNisugataList.concat(tNisugataList)

        // 支払方法
        var wkShiharaiHohoList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mShiharaiHohoList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT021' && elem.kaishaCd === self.currentKaishaCode
        })
        const tShiharaiHohoList = mShiharaiHohoList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkShiharaiHohoList = wkShiharaiHohoList.concat(tShiharaiHohoList)

        // 連絡方法
        var wkRenrakuHohoList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mRenrakuHohoList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT062' && elem.kaishaCd === self.currentKaishaCode
        })
        const tRenrakuHohoList = mRenrakuHohoList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkRenrakuHohoList = wkRenrakuHohoList.concat(tRenrakuHohoList)

        // 運送扱い
        var wkUnsoAtsukaiList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mUnsoAtsukaiList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT064' && elem.kaishaCd === self.currentKaishaCode
        })
        const tUnsoAtsukaiList = mUnsoAtsukaiList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkUnsoAtsukaiList = wkUnsoAtsukaiList.concat(tUnsoAtsukaiList)

        // 入金方法
        var wkNyukinKubunList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mNyukinKubunList = self.kubunList.filter((elem) => {
          return elem.kbnShuruiCd === 'SFF061' && elem.kaishaCd === self.currentKaishaCode
        })
        const tNyukinKubunList = mNyukinKubunList.map(elem => {
          return {
            id: elem.codeNm,
            name: elem.codeNm,
            title: elem.code
          }
        })
        wkNyukinKubunList = wkNyukinKubunList.concat(tNyukinKubunList)

        // 往復種別
        var wkOhfukuSbtList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mOhfukuSbtList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT006' && elem.kaishaCd === self.currentKaishaCode
        })
        const tOhfukuSbtList = mOhfukuSbtList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkOhfukuSbtList = wkOhfukuSbtList.concat(tOhfukuSbtList)

        // 品質種別
        var wkHinsitsuSbtList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mHinsitsuSbtList = self.shubetsuList.filter((elem) => {
          return elem.sbtShuruiCd === 'SBT006' && elem.kaishaCd === self.currentKaishaCode
        })
        const tHinsitsuSbtList = mHinsitsuSbtList.map(elem => {
          return {
            id: elem.sbtNm,
            name: elem.sbtNm,
            title: elem.sbtNm
          }
        })
        wkHinsitsuSbtList = wkHinsitsuSbtList.concat(tHinsitsuSbtList)

        // 定型コース
        var wkTeikeiCourseList = [{ id: '未選択', name: '未選択', title: '未選択' }]
        const mTeikeiCourseList = self.teikeiCourseList.filter(function (elem) {
          return (self.eigyoshoLockFlg || elem.tantoEigyoshoCd === self.usersEigyoshoCd || [undefined, null, ''].includes(elem.tantoEigyoshoCd))
        })
        const tTeikeiCourseList = mTeikeiCourseList.map(elem => {
          return {
            id: elem.teikeiCourseNm,
            name: elem.teikeiCourseNm,
            title: elem.teikeiKihonNo
          }
        })
        wkTeikeiCourseList = wkTeikeiCourseList.concat(tTeikeiCourseList)
        // --------------------------------------------------------------------------------
        // スプレッド用ヘッダ作成
        // --------------------------------------------------------------------------------
        if (![undefined, null, []].includes(self.headers) && self.headers.length > 0) { return resolve() }

        self.headers = []

        // マスタ情報から自動生成
        self.xlsImportMappingList.filter(function (elem) {
          return elem.formatCd === self.conditions.layoutType && elem.hyojiFlg === true
        }).sort((a, b) => {
          if (a.columnNo - b.columnNo !== 0) { return a.columnNo - b.columnNo }
          return -1
        }).forEach((elem) => {
          var dropdownList = null
          if (elem.source === 'EigyoshoList') {
            dropdownList = wkEigyoshoList
          } else if (elem.source === 'HaishasakiKbnList') {
            dropdownList = wkHaishasakiList
          } else if (elem.source === 'YoshasakiList') {
            dropdownList = wkYoshasakiList
          } else if (elem.source === 'JininList') {
            dropdownList = wkJomuinList
          } else if (elem.source === 'SharyoList') {
            dropdownList = wkSharyoList
          } else if (elem.source === 'TokuisakiList') {
            dropdownList = wkTokuisakiList
          } else if (elem.source === 'NiukeninList') {
            dropdownList = wkNiukeninList
          } else if (elem.source === 'HacchakuchiList') {
            dropdownList = wkHacchakuchiList
          } else if (elem.source === 'HatsuchiList') {
            dropdownList = wkHatsuchiList
          } else if (elem.source === 'KeiyuchiList') {
            dropdownList = wkKeiyuchiList
          } else if (elem.source === 'ChakuchiList') {
            dropdownList = wkChakuchiList
          } else if (elem.source === 'ShohinList') {
            dropdownList = wkShohinList
          } else if (elem.source === 'HinmokuShubetsuList') {
            dropdownList = wkHinmokuShubetsuList
          } else if (elem.source === 'TaniSbtList') {
            dropdownList = wkTaniShubetsuList
          } else if (elem.source === 'UnchinKeisanKbnList') {
            dropdownList = wkUnchinKeisanKubunList
          } else if (elem.source === 'ShashuSbtList') {
            dropdownList = wkShashuList
          } else if (elem.source === 'NisugataList') {
            dropdownList = wkNisugataList
          } else if (elem.source === 'ShiharaiHohoList') {
            dropdownList = wkShiharaiHohoList
          } else if (elem.source === 'RenrakuHohoList') {
            dropdownList = wkRenrakuHohoList
          } else if (elem.source === 'UnsoAtsukaiList') {
            dropdownList = wkUnsoAtsukaiList
          } else if (elem.source === 'NyukinKubunList') {
            dropdownList = wkNyukinKubunList
          } else if (elem.source === 'OhfukuSbtList') {
            dropdownList = wkOhfukuSbtList
          } else if (elem.source === 'HinsitsuSbtList') {
            dropdownList = wkHinsitsuSbtList
          } else if (elem.source === 'TeikeiCourseList') {
            dropdownList = wkTeikeiCourseList
          }

          // 請求金額計算用定義
          if (elem.bindItemNm === 'seikyuKingakuGokeiFormula') {
            self.seikyuKingakuGokeiFormula = elem.formulaStrings
          } else if (elem.bindItemNm === 'shiharaiKingakuGokeiFormula') {
            self.shiharaiKingakuGokeiFormula = elem.formulaStrings
          }

          // display_formatが設定されている日付項目は表示のみdisplay_formatで上書きする
          // (type/customInputは変更しない。編集UIやバリデーションは従来通りYYYY/MM/DD)
          // ※ display_format は日付(date/customDate)以外の input_type(numeric/text等)にも
          //   将来的に設定され得る汎用カラムだが、date以外への適用は本対応では未実装。
          //   date以外で表示フォーマットを効かせたい場合は、DdSpreadSheet.vue側に
          //   type別のフォーマット適用処理(例: numericならformula/mask相当の表示上書き、
          //   textなら任意の整形関数)を追加し、ここで elem.inputType に応じて
          //   customXxxFormat相当のプロパティをheaderへ渡すよう拡張すること。
          const isDateColumn = ['date', 'customDate'].includes(elem.inputType)
          const useCustomDateFormat = isDateColumn && !!elem.displayFormat

          // ヘッダー作成
          self.headers.push({
            title: elem.columnNm,
            name: elem.bindItemNm,
            type: elem.standardInputFlg !== true ? null : elem.inputType,
            customInput: elem.standardInputFlg === true ? null : elem.inputType,
            customDateFormat: useCustomDateFormat ? elem.displayFormat : undefined,
            validateType: elem.validateType,
            required: false,
            isRequired: elem.requiredFlg,
            readOnly: elem.readonlyFlg,
            autocomplete: elem.autocompleteFlg,
            width: elem.width + 'px',
            source: dropdownList,
            align: elem.align,
            mask: elem.inputSuffix,
            validateIntDigit: elem.inputIntDigit,
            validateDecimalDigit: elem.inputDecimalDigit,
            // headerStyle: elem.headerStyle === null ? undefined : elem.headerStyle,
            tooltip: elem.requiredFlg ? '必須項目' : undefined,
            columnNo: elem.columnNo,
            fixedHeader: elem.fixedHeaderFlg
          })
        })
        resolve()
      })
    }
  }
}
